import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        root: {
            maxHeight: 545,
            minHeight: 315,
        },
    }
})

export default useStyles
